import CommonActionModal from "../Common/CommonActionModal";
import LetterDetailInner from "./LetterDetailInner";

// icons
import WebAssetIcon from '@mui/icons-material/WebAsset';


class LetterDetail extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: WebAssetIcon,
            buttonLabel: null,
            buttonColor: 'neutral',
            ready: true,
        })
    }

    async setModalOpenFalse() {
        await this.props.callBack()
        this.setState(
            {
                modalOpen: false,
            }
        );
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Исходящее письмо',
            modalIcon: null,
            mainComponent: LetterDetailInner,
            mainComponentProps: {
                letter: this.props.letter,
            },
        }
    }
}

export default LetterDetail